<template>
  <teleport to="#modal_backdrop">
    <div @click.prevent="confirmPopup" class="backdrop-popup"></div>
    <div v-if="currentPopupData.imageUrl" class="modal-popup-image">
      <button class="close-btn" @click="closePopup" aria-label="סגור">
        &times;
      </button>
      <img class="popup-image" :src="popupImageSrc" alt="הודעה" />
    </div>
    <div v-else class="modal-popup">
      <div class="icon-continer">
        <img class="icon" src="/images/ball-icon.png" />
      </div>
      <div class="alart-continer">
        <p class="felix007">
          {{ currentPopupData.content }}
        </p>
        <BaseButton @click="closePopup" class="button"
          ><div>אישור</div>
        </BaseButton>
      </div>
    </div>
  </teleport>
</template>

<script>
import BaseButton from "../helpers/BaseButton.vue";
import { baseUrl } from "../../config";

const DEFAULT_AUTO_CLOSE_SECONDS = 5;

export default {
  components: {
    BaseButton,
  },

  props: {
    popups: {
      type: Array,
      requierd: true,
    },
    currPopup: {
      type: Number,
      requierd: true,
    },
  },
  emits: ["exit-modal", "approve"],
  data() {
    return {
      autoCloseTimer: null,
    };
  },
  computed: {
    currentPopupData() {
      return this.popups[this.currPopup] || {};
    },
    popupImageSrc() {
      if (!this.currentPopupData.imageUrl) return null;
      return `${baseUrl}/alert-images/${this.currentPopupData.imageUrl}`;
    },
  },
  watch: {
    currentPopupData: {
      immediate: true,
      handler(popup) {
        this.clearAutoCloseTimer();
        if (popup && popup.imageUrl && popup.autoClose) {
          const seconds =
            popup.autoCloseSeconds > 0
              ? popup.autoCloseSeconds
              : DEFAULT_AUTO_CLOSE_SECONDS;
          this.autoCloseTimer = setTimeout(() => {
            this.closePopup();
          }, seconds * 1000);
        }
      },
    },
  },
  beforeUnmount() {
    this.clearAutoCloseTimer();
  },
  methods: {
    clearAutoCloseTimer() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    },
    confirmPopup() {
      this.$emit("exit-modal");
    },
    closePopup() {
      this.approve(this.currentPopupData.alert);
    },
    approve(alert) {
      this.$emit("approve", alert);
    },
  },
};
</script>
<style scoped lang="scss">
.categories-filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: center;
  padding: 15px;
}

.line-seperator-one {
  background-image: url("/images/category-filter-seperator.png");
  width: 370px;
  height: 46px;
  display: flex;
  justify-content: center;
}

.backdrop-popup {
  background-color: #000000;
  opacity: 0.6;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 11;
}

.modal-popup {
  display: flex;
  gap: 15px;
  flex-direction: column;
  align-items: center;
  position: absolute;
  z-index: 12;
  border-radius: 40px;
  background: #393945;
  top: 13%;
  right: 6%;
  width: 100%;
  max-width: 330px;
  padding: 20px;
  animation: popupEnter 1s;

  @media (min-width: 602px) {
    top: 50%;
    right: auto;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: enterCentered 1s;
  }

  .icon-continer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .alart-continer {
    width: 100%;
    max-height: 350px;
    overflow-y: auto;
    min-height: 300px;
    padding: 1px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .text-continer {
    padding: 0px 10px;
    align-items: flex-start;
  }
  .icon {
    width: 67px;
    height: 73px;
  }

  h1 {
    margin: 0;
    padding: 0;
    color: $primaryTextColor;
    font-size: $largTextSize;
    letter-spacing: 0.04px;
  }

  span {
    color: black;
    font-weight: 300;
    font-size: $largestTextSize;
    // padding: 0px 20px;
  }
  p {
    font-size: $largTextSize;
    color: white;
    text-align: center;
  }
  .button {
    width: 100%;
  }
}

.modal-popup-image {
  position: absolute;
  z-index: 12;
  top: 13%;
  right: 6%;
  width: 100%;
  max-width: min(90vw, 500px);
  animation: popupEnter 1s;

  @media (min-width: 602px) {
    top: 50%;
    right: auto;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: enterCentered 1s;
  }

  .popup-image {
    width: 100%;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 20px;
    display: block;
  }

  .close-btn {
    position: absolute;
    top: -14px;
    left: -14px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    background: #393945;
    color: $primaryTextColor;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// self-contained instead of relying on the shared global .enter class, so there's no
// cascade fight over the "animation"/"transform" properties with these elements' own rules
@keyframes popupEnter {
  0% {
    opacity: 0;
    transform: translate3d(0, -200px, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes enterCentered {
  0% {
    opacity: 0;
    transform: translate(-50%, calc(-50% - 200px));
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
</style>
